<template>
  <div class="product-list-checkbox">
    <div class="select-all" v-if="!checkDisabled">
      <!-- <el-checkbox @change="change" >全选</el-checkbox> -->
      <el-col :span="12">
        <div class="expressBtn all" :class="{is_active:allSelect}" @click="selectAll()">全部商品</div>
      </el-col>
      <el-col :span="12">
        <div class="expressBtn notAll" :class="{is_active:!allSelect}" @click="notSelectAll()">部分商品</div>
      </el-col>
    </div>
    <ul v-if="order.type == 0">
      <li class="clearfix" v-for="(line,index) in groupOrderLine" :key="index">
        <template v-if="checkDisabled">
          <template v-if="line.checked">
            <div class="content-container no-margin">
              <div class="clearfix">
                <div class="img-container">
                  <img v-if="line.picture" :src="line.picture"/>
                  <img  v-else src="https://pic.joyorders.com/blank.png"/>
                </div>
                <div class="line-des">
                  <p class="name">{{showProductName(line)}}</p>
                  <p>
                    <span v-show="!line.isHideSpecLabel">规格：</span>
                    <span v-html="formatSpec(line.spec,line)"></span>
                  </p>
                  <p v-if="!numEditable"><span>数量：</span><span>{{line.selectNum}}</span></p>
                  <el-select @change="changeNum(index,line.selectNum,line.number)" v-if="numEditable" class="inline-block" v-model="line.selectNum" placeholder="">
                    <el-option
                      v-for="item in Number(line.number)"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="checkbox-container">
            <el-checkbox @change="selectLine(line)" v-model="line.checked"></el-checkbox>
          </div>
          <div class="content-container">
            <div class="clearfix">
              <div class="img-container">
                <img v-if="line.picture" :src="line.picture"/>
                <img  v-else src="https://pic.joyorders.com/blank.png"/>
              </div>
              <div class="line-des">
                <p class="name">{{showProductName(line)}}</p>
                <p><span v-show="!line.isHideSpecLabel">规格：</span><span v-html="formatSpec(line.spec,line)"></span></p>
                <p v-if="!numEditable"><span>数量：</span>{{line.number}}</p>
                <el-select @change="changeNum(index,line.selectNum,line.number)" v-if="numEditable" class="inline-block" v-model="line.selectNum" placeholder="">
                  <el-option
                    v-for="item in Number(line.number)"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </template>
      </li>
    </ul>
    <ul v-if="order.type==2" class="noBorder">
      <li v-for="(good,index) in goods_info"  class="good_info">
        <el-row >
          <el-col :span="6">
              <!-- <el-upload
              :action="API_HOST + '/api/order.php?api=upload_good_picture'"
              :on-success="handleSuccess"
              :headers="headers"
              :item="good"
              name="good_picture" style="display:inline-block">
              <img v-if="good.image" :src="good.image"/>
              <img v-if="!good.image" src="../../../../ico/uploadpic@2x.png"/>
              </el-upload> -->
              <img v-if="!good.image" src="../../../../ico/uploadpic@2x.png"  @click="showOrderVoucher(index)"/>
              <img v-else :src="good.image"  @click="showOrderVoucher(index)"/>
              <!-- <uploader
              icon="ico ico-uploadpic mt15"
              :item="good"
              :opreation="'发货'"
              :action="API_HOST + '/api/order.php?api=upload_good_picture'"
              v-on:onUploadSuccess="onUploadSuccess"
              ></uploader> -->
          </el-col>
          <el-col :span="18">
            <div>
              <el-input
                type="textarea"
                :rows="2"
                :placeholder="operation=='发货'? '填写已发货商品名称和信息':'填写要取消的商品名称和信息'"
                v-model="good.remark">
              </el-input>
              <div v-if="need_input_price">
                <el-input class="need_input_price" style="width:80%;"
                  placeholder="填写要取消的商品价格"
                  v-model="good.inputPrice">
                </el-input>
                <label>{{order.price_info.goods_price.currency}}</label>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="delete" @click="del(index)">
          <i class="el-icon-delete"></i>
        </div>
      </li>
      <li class="addGoodInfo">
        <div class="addBtn" @click="addGoodInfo()">
          <i class="el-icon-circle-plus-outline"></i><span>继续添加</span>
        </div>
      </li>

    </ul>
  </div>
</template>

<script>
import Uploader from '../../../../components/Uploader'
import { API_HOST,specOrder,SPEC_MAPPER } from '../../../../services/constant.js'
import {showProductName,formatSpec} from '../../../../services/tools.js'

let _ = require('lodash')

export default {
  name: 'OrderList',
  props: ['groupOrderLine', 'order', 'numEditable', 'operation', 'goods_info','need_input_price','checkDisabled'],
  components: {
    Uploader: Uploader
  },
  data () {
    return {
      showProductName:showProductName,
      formatSpec:formatSpec,
      selectNum: 0,
      allSelect: true,
      API_HOST: API_HOST,
      headers: {},
      currentSelectIndex:0 // 选中替换图片的index

    }
  },
  created () {
    let flag = false
      _.each(this.groupOrderLine, line => {
        if (!line.checked) {
          flag = true
          // return false
        }
      })
    this.allSelect = !flag
    this.headers.token = this.$localStorage.get('token')
    /*if (this.allSelect) {
      _.each(this.groupOrderLine, line => {
        line.checked = true
      })
      this.$forceUpdate()
    }
    // if(this.order.type == '2'){
    //   this.allSelect = true
    // }else{
    //   this.allSelect = false
    // }
    _.each(this.groupOrderLine, line => {
      this.selectNum = Number(line.number)
      line.selectNum = Number(line.number)
    })*/
  },
  methods: {
    // 跳转到下单凭证
    showOrderVoucher (i) {
      let orderVoucher = document.getElementById('voucher' + this.order.id)
      this.currentSelectIndex = i // d
      this.$emit('showChooseImage', true)
      orderVoucher.click()
    },
    updateGoodInfoImg(res){
      this.goods_info[this.currentSelectIndex].image=res;
    },
    addGoodInfo () {
      this.goods_info.push(
        {image: '', remark: '', id: new Date().getTime()}
      )
      this.$forceUpdate()
    },
    del (index) {
      this.goods_info.splice(index, 1)
    },
    // handleSuccess: function(response, file, fileList) {
    //   console.log(file)
    //   this.isProgressing = false
    //   if (response.status !== 'ok') {
    //     this.$message.error('上传失败：'+response.result)
    //     return;
    //   }

    // },
    onUploadSuccess: function (res) {
      // console.log(res)
      let result = res.response.result
      for (let good of this.goods_info) {
        console.log(good.id, res.item.id)
        if (good.id === res.item.id) {
          good.image = result
          this.$forceUpdate()
          return
        }
      } 
      this.goods_info[this.currentSelectIndex].image = result
      this.$forceUpdate()
    },
    selectAll () {
      this.$emit('changeType', '2')
      if (this.allSelect) {
        return
      }
      this.allSelect = true
      _.each(this.groupOrderLine, line => {
        line.checked = true
        line.selectNum = line.number
        // console.log(line)
      })
      this.$forceUpdate()
    },
    notSelectAll () {
      this.$emit('changeType', '1')
      if (!this.allSelect) {
        return
      }
      if (this.order.type == 0 && this.groupOrderLine && this.groupOrderLine.length === 1 && ~~this.groupOrderLine[0].number === 1) {
        return
      }
      this.allSelect = false
      _.each(this.groupOrderLine, line => {
        line.checked = false
      })
      this.$forceUpdate()
    },
    change (val) {
      _.each(this.groupOrderLine, line => {
        line.checked = val
      })
      this.$forceUpdate()
    },
    changeNum (index, selectNum, max) {
      let flag = false
      _.each(this.groupOrderLine, line => {
        if (!line.checked) {
          flag = true
          // return false
        }
      })
      this.allSelect = !(selectNum < ~~max) && !flag
      this.$forceUpdate()
    },
    selectLine () {
      let flag = false
      _.each(this.groupOrderLine, line => {
        if (line.selectNum < line.number) {
          flag = true
          // return false
        }
        if (!line.checked) {
          flag = true
          return false
        }
      })
      this.allSelect = !flag
      this.$forceUpdate()
      this.$emit('checkNext')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.product-list-checkbox {
  ul {
    // border-top: 1px solid #CDCDCD;
    //border-bottom: 1px solid #CDCDCD;
    margin-top: 10px;
    max-height: 286px;
    overflow-y: auto;
    overflow-x: hidden;
    &.noBorder{
      border-bottom:none !important;
    }
    .good_info{
      position: relative;
      border: 1px solid #ccc;
      margin-top: 20px;
      &:first-child{
        margin-top: 0px;
      }
      .delete {
        cursor: pointer;
        position: absolute;
        right: 6px;
        top: 10px;
      }
      img {
        padding: 10px;
        height: 90px;
        width: 90px;
        // -o-object-fit: contain;
        object-fit: contain;
      }
    }
    .addGoodInfo{
      margin-top: 10px;
      .addBtn{
        cursor: pointer;
        display: inline-block;
        i{
          font-size: 16px;
          margin-right: 10px;
        }
      }

    }
    .content-container {
      padding-right: 60px;
      width: 100%;
      &.no-margin{
        margin-left:0;
        padding-right:0;
      }
      & > div {
        border-bottom: 1px solid #CDCDCD;
        padding: 20px 0;
        display: flex;
      }

      .inline-block {
        margin-left: 0;
      }
    }

    .img-container {
      width: 100px;
      height: 100px;
      img {
        width: 100px;
        height:100px;
        object-fit: contain;
      }
    }

    li {
      &:last-child {
        .content-container {
          & > div {
            border-bottom: none;
          }
        }
      }
    }
  }

  .line-des {
    margin-left: 15px;
    position: relative;
    top:-6px;
    p {
      line-height: 24px;
      word-break: break-all;
      span {
        color: #888888;
      }
    }
  }
}
.clearfix{
  display: flex;
  justify-content: space-around;
}
.checkbox-container {
  margin-top: 60px;
  width: 30px;
}
.select-all {
  overflow: hidden;
  border-radius: 3px;
  // border: 1px solid #ccc;
  .expressBtn{
    text-align: center;
    display: inline-block;
    border: 1px solid #ccc;
    box-sizing: border-box;
    width: 100%;
    padding: 15px 0;
    cursor: pointer;
    &.is_active{
      background-color: #333;
      border: 1px solid transparent;
      color: #fff;
    }
    &.all {
      border-right: none;
    }
    &.notAll{
      border-left: none;
    }
  }
}
</style>
<style lang="scss">
.product-list-checkbox {
  .select-all {
    .el-checkbox__label {
      color: #888888!important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/single/ExceptionProductList.vue